import { render, staticRenderFns } from "./ChecklistsList.vue?vue&type=template&id=5b3b49a2"
import script from "./ChecklistsList.vue?vue&type=script&lang=js"
export * from "./ChecklistsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports